import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Fix for mobile viewport units (address bar show/hide) -------------------------------------------------
// Use a CSS variable --vh that holds 1% of the actual window.innerHeight.
// Then reference `calc(var(--vh, 1vh) * 100)` in CSS instead of 100vh.
// This avoids layout jumps when mobile browsers show/hide the address bar.
function setVhCssVariable() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setVhCssVariable();
window.addEventListener('resize', setVhCssVariable);
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', setVhCssVariable);
}
// --------------------------------------------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
